'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates a interactive window object
 *
 * @class
 */

class Tooltip extends Core {
 
    _defaults() {
        return {
            target: 'body',
            fields: {}
        };
    }
    
    constructor(options) {
        super(options);
        
        this.template = `
            <div class='editor__tooltip editor__tooltip--w'>
                <div class="editor__tooltip__arrow"></div>
                <div class="editor__tooltip__inner js-editor__tooltip__inner"></div>
            </div>
        `;

        super.render();

        this.direction = 'w';
    }

    /**
     * setTitle
     * @param {String} title - the title of the tooltip
     */

    setTitle(title){
        $(".js-editor__tooltip__inner", this.$el).html(title);
    }

    /**
     * set position
     * @param {Int} posX - x pos of tooltip
     * @param {Int} posY - y pos of tooltip
     */

    setPos(posX, posY) {
        let width = this.$el.outerWidth();
        let height = this.$el.outerHeight();
        
        /////////////////////////////
        // [element box]           //
        // [x,y] -> [posX, posY]   //
        // position of tooltip     //
        //                         //
        //  ------(x,y)-------     //
        // |                  |    //   
        // |                  |    //   
        // (x,y)             (x,y) //
        // |                  |    //
        // |                  |    //
        //  ------(x,y)-------     //
        /////////////////////////////
        
        //update final position of tooltip respective to the element depending on direction
        switch(this.direction) {
            case 'w':
                posY = posY - height / 2;
            break;

            case 'e':
                posX = posX - width;
                posY = posY - height / 2;
            break;

            case 'n':
                posX = posX - width / 2;
            break;

            case 's':
                posX = posX - width / 2;
                posY = posY - height;
            break;
        }

        this.$el.css({
            left: posX,
            top: posY
        });
    }

    /**
     * set direction
     * @param {String} direction - n/e/s/w
     */

    setDirection(direction){
        this.direction = direction;

        this.$el.removeClass('editor__tooltip--e editor__tooltip--s editor__tooltip--w editor__tooltip--n');
        this.$el.addClass('editor__tooltip--'+direction);
    }

    /**
     * Show
     */

    show(){
        this.$el.show();
    }

    /**
     * Hide
     */

    hide(){
        this.$el.hide();
    }
}
module.exports = Tooltip;